import { FileSelector } from "components/base/Form";
import ImagesGridView from "components/base/ImagesGridView";
import useFileUploader from "hooks/useFileUploader";
import { useEffect, useState } from "react";

const ImagesView = ({
  name,
  images,
  onChange,
  enablePasteFromClipboard = true,
  extraImageSelector = null,
}) => {
  const { isUploading, handleFileUpload } = useFileUploader(
    handleUploadedFiles,
    process.env.NODE_ENV === "production" ? "AWS" : "qiniu",
  );
  const [isPasteListenerActive, setIsPasteListenerActive] = useState(false);

  function togglePasteListener() {
    setIsPasteListenerActive(!isPasteListenerActive);
  }

  const handlePaste = (event) => {
    if (!enablePasteFromClipboard || !isPasteListenerActive) return;

    const clipboardData = event.clipboardData || window.clipboardData;

    // Check if the pasted data contains an image
    if (clipboardData && clipboardData.items) {
      let images = [];
      for (let item of clipboardData.items) {
        if (item.kind === "file" && item.type.startsWith("image/")) {
          const file = item.getAsFile();
          console.log("file", file);
          images.push(file);
        }
      }
      if (images.length > 0) {
        handleFileUpload(images);
      } else {
        window.alert("No images found in clipboard");
      }
    }

    // Prevent the default paste behavior
    event.preventDefault();
  };

  useEffect(() => {
    // listen to paste events
    document.addEventListener("paste", handlePaste);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  });

  function handleUploadedFiles(newUrls) {
    const originalUrls = images.map((i) => i.url);
    onChange({ imageUrls: [...originalUrls, ...newUrls] });
  }

  function imageDeleteHandler(index) {
    if (window.confirm("Are you sure you want to delete this image?")) {
      const newImages = images.map((i) => i.url);
      newImages.splice(index, 1);
      onChange({ imageUrls: newImages });
    }
  }

  return (
    <div className="card space-y-2">
      <h5>Images</h5>

      {images.length > 0 && (
        <ImagesGridView
          previewTitle={name}
          images={images}
          deleteHandler={imageDeleteHandler}
        />
      )}

      <div className=" space-y-1">
        <div className="flex space-x-4 items-center">
          <FileSelector
            title="+ Upload Images"
            uploading={isUploading}
            onChange={(e) => {
              const files = [...e.target.files];
              handleFileUpload(files);
              e.target.value = null;
            }}
          />
          {extraImageSelector}
        </div>

        {enablePasteFromClipboard ? (
          <div className="flex items-center space-x-2">
            <label htmlFor="id-paste-from-clipboard">
              Paste from Clipboard
            </label>
            <input
              id="id-paste-from-clipboard"
              type="checkbox"
              checked={isPasteListenerActive}
              onChange={togglePasteListener}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ImagesView;
